/**
 * Walks Lexical JSON (serialized editor state) and collects Mention nodes.
 */
export interface LexicalMention {
  name: string;
  value: string;
  type: 'employee' | 'team';
  id: string;
}

export function findMentions(str: string): LexicalMention[] {
  const blob = JSON.parse(str);

  const mentions: LexicalMention[] = [];
  const seenIds = new Set<string>();
  const stack: any[] = [blob];

  while (stack.length) {
    const current = stack.pop();

    if (current && typeof current === 'object') {
      if (current.type === 'Mention' && !seenIds.has(current.id)) {
        seenIds.add(current.id);
        mentions.push({
          name: current.trigger,
          value: current.value,
          type: current.mentionType,
          id: current.id,
        });
      }

      for (const val of Object.values(current)) {
        if (typeof val === 'object') {
          stack.push(val);
        }
      }
    }
  }

  return mentions;
}
